import { Component, HostListener, OnInit } from '@angular/core';
import { AdminService } from '../services/admin/admin.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-notinew',
  templateUrl: './notinew.component.html',
  styleUrls: ['./notinew.component.css']
})
export class NotinewComponent implements OnInit {
  // Formulario para notificaciones inmediatas
  form: any = {
    tipo_envio: 'individual',
    user_ids: [],
    rol: '',
    ciudad_id: null,
    titulo: '',
    cuerpo: '',
    datos: {
      tipo: 'promocion',
      id_promocion: '789',
      descuento: '25%',
      id_evento: '10',
      fecha: '22/05/2025'
    },
    imagen_base64: ''
  };

  // Formulario para notificaciones programadas - Con tipo de envío completo
  scheduledForm: any = {
    nombre: '',
    descripcion: '',
    titulo: '',
    cuerpo: '',
    tipo_envio: 'todos', // Default según TIPO_ENVIO_CHOICES
    tipo_programacion: 'unica', // Default según TIPO_PROGRAMACION_CHOICES
    fecha_inicio: '',
    fecha_fin: '', // Se calculará automáticamente
    hora_envio: '09:00:00',
    datos: {
      categoria: 'general',
      accion: ''
    },
    // Campos adicionales para tipos de envío específicos
    user_ids: [],
    rol: '',
    ciudad_id: null
  };

  // Configuraciones predefinidas para programación rápida
  quickScheduleTemplates = {
    ejercicio: {
      nombre: 'Recordatorio diario de ejercicio',
      descripcion: 'Notificación para motivar ejercicio diario',
      titulo: '¡Hora de ejercitarse!',
      cuerpo: 'No olvides hacer ejercicio hoy. Tu salud es importante.',
      categoria: 'salud',
      accion: 'abrir_seccion_ejercicios'
    },
    medicamento: {
      nombre: 'Recordatorio de medicamento',
      descripcion: 'Recordatorio para tomar medicamentos',
      titulo: '⏰ Hora del medicamento',
      cuerpo: 'Es hora de tomar tu medicamento. Cuida tu salud.',
      categoria: 'medicamento',
      accion: 'abrir_medicamentos'
    },
    citas: {
      nombre: 'Recordatorio de citas médicas',
      descripcion: 'Recordatorio para asistir a citas médicas',
      titulo: '📅 Cita médica próxima',
      cuerpo: 'Recuerda que tienes una cita médica programada.',
      categoria: 'citas',
      accion: 'abrir_citas'
    },
    promocion: {
      nombre: 'Promoción especial',
      descripcion: 'Notificación de ofertas y promociones',
      titulo: '🎉 ¡Oferta especial!',
      cuerpo: 'Aprovecha nuestra promoción especial solo para ti.',
      categoria: 'promocion',
      accion: 'abrir_promociones'
    }
  };

  // Opciones de configuración - SEGÚN TU BACKEND
  tiposProgramacion = [
    { value: 'unica', label: 'Única vez', defaultDuration: 1 },
    { value: 'diaria', label: 'Diaria', defaultDuration: 30 },
    { value: 'semanal', label: 'Semanal', defaultDuration: 90 },
    { value: 'mensual', label: 'Mensual', defaultDuration: 365 },
    { value: 'personalizada', label: 'Personalizada (cron)', defaultDuration: 30 }
  ];

  categorias = [
    { value: 'general', label: 'General' },
    { value: 'salud', label: 'Salud' },
    { value: 'medicamento', label: 'Medicamento' },
    { value: 'citas', label: 'Citas médicas' },
    { value: 'promocion', label: 'Promociones' },
    { value: 'evento', label: 'Eventos' },
    { value: 'educativo', label: 'Educativo' }
  ];

  roles = [
    { value: 'medic', label: 'Médico' },
    { value: 'assistant', label: 'Asistente' },
    { value: 'comercial', label: 'Comercial' }
  ];

  userSearch: string = '';
  filteredUsers: any[] = [];
  ciudades: any[] = [];
  showUserDropdown = false;

  // Control de UI
  notificationType: 'immediate' | 'scheduled' = 'immediate';

  constructor(
    private notificationService: AdminService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.buscarUsuarios(); // carga inicial (vacía)
    this.getCiudades();
    this.initializeScheduledFormDates();
  }

  initializeScheduledFormDates(): void {
    // Establecer fecha de inicio como hoy
    const today = new Date();
    this.scheduledForm.fecha_inicio = this.formatDateForInput(today);

    // Para notificaciones programadas, fecha_fin se calculará automáticamente en el backend
    // No necesitamos setearla aquí
  }

  formatDateForInput(date: Date): string {
    return date.toISOString().slice(0, 16); // formato: YYYY-MM-DDTHH:mm
  }

  // Cambiar tipo de notificación
  setNotificationType(type: 'immediate' | 'scheduled'): void {
    this.notificationType = type;
    // Cerrar dropdown de usuarios si está abierto
    this.showUserDropdown = false;
    // Limpiar búsqueda de usuarios
    this.userSearch = '';
    // Limpiar usuarios filtrados
    this.filteredUsers = [];
  }

  toggleUserDropdown(): void {
    this.showUserDropdown = !this.showUserDropdown;
  }

  // Método original para abrir modal (ahora con más opciones)
  abrirModalProgramarNotificacion(): void {
    swal({
      title: '<h4 class="mb-0">Programar Notificación</h4>',
      html: `
        <div class="text-left">
          <div class="form-group mb-3">
            <label><strong>Tipo de programación:</strong></label>
            <select id="swal-tipo-programacion" class="form-control">
              <option value="diaria">Diaria</option>
              <option value="semanal">Semanal</option>
              <option value="mensual">Mensual</option>
              <option value="unica">Única vez</option>
            </select>
          </div>
          <div class="form-group mb-3">
            <label><strong>Nombre:</strong></label>
            <input type="text" id="swal-nombre" class="form-control" value="Recordatorio de ejercicio">
          </div>
          <div class="form-group mb-3">
            <label><strong>Título:</strong></label>
            <input type="text" id="swal-titulo" class="form-control" value="¡Hora de ejercitarse!">
          </div>
          <div class="form-group mb-3">
            <label><strong>Hora de envío:</strong></label>
            <input type="time" id="swal-hora" class="form-control" value="09:00">
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: '<p>Programar Notificación</p>',
      cancelButtonText: '<p>Cancelar</p>',
      confirmButtonColor: '#6eceee',
      cancelButtonColor: '#f27474',
      width: 600,
      preConfirm: () => {
        const tipoProgramacion = (document.getElementById('swal-tipo-programacion') as HTMLSelectElement).value;
        const nombre = (document.getElementById('swal-nombre') as HTMLInputElement).value;
        const titulo = (document.getElementById('swal-titulo') as HTMLInputElement).value;
        const hora = (document.getElementById('swal-hora') as HTMLInputElement).value;

        if (!nombre || !titulo || !hora) {
          swal.showValidationMessage('Por favor completa todos los campos');
          return false;
        }

        return { tipoProgramacion, nombre, titulo, hora };
      }
    }).then((result) => {
      if (result.value) { // En versiones anteriores de SweetAlert2 se usa result.value
        this.crearNotificacionProgramadaRapida(result.value);
      }
    });
  }

  crearNotificacionProgramadaRapida(config: any): void {
    // Si config es undefined, significa que se canceló
    if (!config) {
      return;
    }

    // Calcular fecha de fin basada en la duración especificada
    const fechaInicio = new Date();
    const fechaFin = new Date();

    // Obtener duración por defecto según el tipo
    const tipoConfig = this.tiposProgramacion.find(t => t.value === config.tipoProgramacion);
    const duracion = tipoConfig ? tipoConfig.defaultDuration : 30;
    fechaFin.setDate(fechaInicio.getDate() + duracion);

    const payload = {
      nombre: config.nombre,
      descripcion: `Notificación ${config.tipoProgramacion} - ${config.nombre}`,
      titulo: config.titulo,
      cuerpo: 'No olvides hacer ejercicio hoy. Tu salud es importante.', // Por defecto
      tipo_envio: "todos",
      tipo_programacion: config.tipoProgramacion,
      fecha_inicio: fechaInicio.toISOString(),
      hora_envio: config.hora + ":00",
      datos: {
        categoria: 'salud', // Por defecto
        accion: 'abrir_seccion_ejercicios' // Por defecto
      },
      fecha_fin: fechaFin.toISOString()
    };

    this.notificationService.sendScheduledNotification(payload).subscribe({
      next: (response: any) => {
        const htmlMsg = `
          <p><strong>${response.message || 'Notificación programada exitosamente'}</strong></p>
          <p><strong>Detalles:</strong></p>
          <p>• Tipo: ${config.tipoProgramacion}</p>
          <p>• Hora: ${config.hora}</p>
          <p>• Duración: ${duracion} días</p>
          <p>• Categoría: salud</p>
          ${response.usuarios_afectados ? `<p>• Usuarios afectados: ${response.usuarios_afectados}</p>` : ''}
        `;
        swal({
          title: '<img src="assets/icons/good.png" width="80px">',
          html: htmlMsg,
          confirmButtonText: '<p>Aceptar</p>',
          confirmButtonColor: '#6eceee',
          width: 600
        });
      },
      error: (err) => {
        console.error(err);
        const errorMsg = err.error.message || err.message || 'Error desconocido';
        swal({
          title: '<img src="assets/icons/error.png" width="80px">',
          html: `<p>Error al programar la notificación:</p><p><small>${errorMsg}</small></p>`,
          confirmButtonText: '<p>Aceptar</p>',
          confirmButtonColor: '#f27474',
        });
      }
    });
  }

  // Cierra si haces clic fuera
  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const isInside = target.closest('.form-group');
    if (!isInside) {
      this.showUserDropdown = false;
    }
  }

  // Muestra los nombres seleccionados
  getSelectedUserNames(): string {
    const selected = this.filteredUsers.filter(user =>
      this.form.user_ids.includes(user.id)
    );
    return selected.map(u => u.name).join(', ');
  }

  getCiudades(): void {
    this.notificationService.list_ciudades().subscribe((res: any) => {
      this.ciudades = res;
    });
  }

  buscarUsuarios(): void {
    const currentForm = this.notificationType === 'immediate' ? this.form : this.scheduledForm;

    if (currentForm.tipo_envio === 'todos') {
      this.filteredUsers = [];
      return;
    }

    const params: any = {};

    if (this.userSearch) params.search = this.userSearch;
    if (currentForm.tipo_envio === 'rol' && currentForm.rol) params.role = currentForm.rol;
    if (currentForm.tipo_envio === 'ciudad' && currentForm.ciudad_id) params.city_id = currentForm.ciudad_id;

    this.notificationService.getFilteredUsers(params).subscribe(users => {
      this.filteredUsers = users;
    });
  }

  toggleUserSelection(userId: number, selected: boolean): void {
    const currentForm = this.notificationType === 'immediate' ? this.form : this.scheduledForm;

    if (selected) {
      if (!currentForm.user_ids.includes(userId)) {
        currentForm.user_ids.push(userId);
      }
    } else {
      currentForm.user_ids = currentForm.user_ids.filter(id => id !== userId);
    }
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        if (this.notificationType === 'immediate') {
          this.form.imagen_base64 = reader.result as string;
        } else {
          this.scheduledForm.imagen_base64 = reader.result as string;
        }
      };
      reader.readAsDataURL(file);
    }
  }

  // Método para validar formulario antes del envío
  validateScheduledForm(): { isValid: boolean; errors: string[] } {
    const errors: string[] = [];

    // Validaciones básicas
    if (!this.scheduledForm.nombre.trim()) {
      errors.push('El nombre es obligatorio');
    }

    if (!this.scheduledForm.titulo.trim()) {
      errors.push('El título es obligatorio');
    }

    if (!this.scheduledForm.cuerpo.trim()) {
      errors.push('El cuerpo del mensaje es obligatorio');
    }

    if (!this.scheduledForm.tipo_programacion) {
      errors.push('Debe seleccionar un tipo de programación');
    }

    if (!this.scheduledForm.fecha_inicio) {
      errors.push('La fecha de inicio es obligatoria');
    }

    if (!this.scheduledForm.hora_envio) {
      errors.push('La hora de envío es obligatoria');
    }

    if (!this.scheduledForm.datos.categoria) {
      errors.push('La categoría es obligatoria');
    }

    // Validaciones específicas por tipo de envío
    if (this.scheduledForm.tipo_envio === 'individual' && (!this.scheduledForm.user_ids || this.scheduledForm.user_ids.length === 0)) {
      errors.push('Debe seleccionar al menos un usuario para envío individual');
    }

    if (this.scheduledForm.tipo_envio === 'rol' && !this.scheduledForm.rol) {
      errors.push('Debe seleccionar un rol');
    }

    if (this.scheduledForm.tipo_envio === 'ciudad' && !this.scheduledForm.ciudad_id) {
      errors.push('Debe seleccionar una ciudad');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }

  // Enviar notificación inmediata
  enviarNotificacion() {
    const payload: any = {
      titulo: this.form.titulo,
      cuerpo: this.form.cuerpo,
      datos: this.form.datos
    };

    // Agregar imagen solo si existe
    if (this.form.imagen_base64) {
      payload.imagen_base64 = this.form.imagen_base64;
    }

    switch (this.form.tipo_envio) {
      case 'individual':
        payload.tipo_envio = 'individual';
        payload.user_ids = this.form.user_ids;
        break;
      case 'rol':
        payload.tipo_envio = 'rol';
        payload.rol = this.form.rol;
        break;
      case 'ciudad':
        payload.tipo_envio = 'ciudad';
        payload.ciudad_id = this.form.ciudad_id;
        break;
      case 'todos':
        payload.tipo_envio = 'todos';
        break;
    }

    console.log('Payload inmediata enviado:', payload);

    this.notificationService.sendNotification(payload).subscribe({
      next: (response: any) => {
        const htmlMsg = `
          <p><strong>${response.message}</strong></p>
          <p>Usuarios afectados: ${response.usuarios_afectados}</p>
          <p>Total dispositivos: ${response.total_dispositivos}</p>
        `;
        swal({
          title: '<img src="assets/icons/good.png" width="80px">',
          html: htmlMsg,
          confirmButtonText: '<p>Aceptar</p>',
          confirmButtonColor: '#6eceee',
          width: 600
        }).then(() => this.router.navigate(['/admin/notinew']));
      },
      error: (err) => {
        console.error('Error completo:', err);
        const errorMsg = err.error.message || err.message || 'Error desconocido';
        swal({
          title: '<img src="assets/icons/error.png" width="80px">',
          html: `<p>Error al enviar la notificación:</p><p><small>${errorMsg}</small></p>`,
          confirmButtonText: '<p>Aceptar</p>',
          confirmButtonColor: '#f27474',
        });
      }
    });
  }

  // Enviar notificación programada - Con soporte completo para tipos de envío
  enviarNotificacionProgramada() {
    // Validar formulario primero
    const validation = this.validateScheduledForm();

    if (!validation.isValid) {
      swal({
        title: '<img src="assets/icons/error.png" width="80px">',
        html: `<p>Por favor corrige los siguientes errores:</p><ul style="text-align: left;">${validation.errors.map(error => `<li>${error}</li>`).join('')}</ul>`,
        confirmButtonText: '<p>Aceptar</p>',
        confirmButtonColor: '#f27474',
      });
      return;
    }

    // Calcular fecha_fin automáticamente (30 días después de fecha_inicio por defecto)
    const fechaInicio = new Date(this.scheduledForm.fecha_inicio);
    const fechaFin = new Date(fechaInicio);
    fechaFin.setDate(fechaInicio.getDate() + 30);

    // Payload base
    const payload: any = {
      nombre: this.scheduledForm.nombre,
      descripcion: this.scheduledForm.descripcion,
      titulo: this.scheduledForm.titulo,
      cuerpo: this.scheduledForm.cuerpo,
      tipo_envio: this.scheduledForm.tipo_envio,
      tipo_programacion: this.scheduledForm.tipo_programacion,
      fecha_inicio: this.scheduledForm.fecha_inicio,
      fecha_fin: fechaFin.toISOString(),
      hora_envio: this.scheduledForm.hora_envio,
      datos: {
        categoria: this.scheduledForm.datos.categoria,
        accion: this.scheduledForm.datos.accion
      }
    };

    // Agregar campos específicos según el tipo de envío
    switch (this.scheduledForm.tipo_envio) {
      case 'individual':
        payload.user_ids = this.scheduledForm.user_ids;
        break;
      case 'rol':
        payload.rol = this.scheduledForm.rol;
        break;
      case 'ciudad':
        payload.ciudad_id = this.scheduledForm.ciudad_id;
        break;
      case 'todos':
        // No necesita campos adicionales
        break;
    }

    console.log('Payload programada enviado:', payload);

    this.notificationService.sendScheduledNotification(payload).subscribe({
      next: (response: any) => {
        const htmlMsg = `
          <p><strong>${response.message || 'Notificación programada exitosamente'}</strong></p>
          <p>Tipo: ${this.scheduledForm.tipo_programacion}</p>
          <p>Envío: ${this.scheduledForm.tipo_envio}</p>
          <p>Inicio: ${this.scheduledForm.fecha_inicio}</p>
          <p>Hora: ${this.scheduledForm.hora_envio}</p>
          ${response.usuarios_afectados ? `<p>Usuarios: ${response.usuarios_afectados}</p>` : ''}
        `;
        swal({
          title: '<img src="assets/icons/good.png" width="80px">',
          html: htmlMsg,
          confirmButtonText: '<p>Aceptar</p>',
          confirmButtonColor: '#6eceee',
          width: 600
        }).then(() => {
          this.resetScheduledForm();
        });
      },
      error: (err) => {
        console.error('Error completo:', err);
        const errorMsg = err.error.message || err.message || 'Error desconocido';
        swal({
          title: '<img src="assets/icons/error.png" width="80px">',
          html: `<p>Error al programar la notificación:</p><p><small>${errorMsg}</small></p>`,
          confirmButtonText: '<p>Aceptar</p>',
          confirmButtonColor: '#f27474',
        });
      }
    });
  }

  resetScheduledForm(): void {
    this.scheduledForm = {
      nombre: '',
      descripcion: '',
      titulo: '',
      cuerpo: '',
      tipo_envio: 'todos', // Default según backend
      tipo_programacion: 'unica', // Default según backend
      fecha_inicio: '',
      fecha_fin: '', // Se calculará automáticamente
      hora_envio: '09:00:00',
      datos: {
        categoria: 'general',
        accion: ''
      },
      // Campos adicionales para tipos de envío específicos
      user_ids: [],
      rol: '',
      ciudad_id: null
    };
    this.initializeScheduledFormDates();
  }

  // Método para aplicar una plantilla al formulario programado
  applyTemplate(templateKey: string): void {
    const template = this.quickScheduleTemplates[templateKey];
    if (template) {
      this.scheduledForm.nombre = template.nombre;
      this.scheduledForm.descripcion = template.descripcion;
      this.scheduledForm.titulo = template.titulo;
      this.scheduledForm.cuerpo = template.cuerpo;
      this.scheduledForm.datos.categoria = template.categoria;
      this.scheduledForm.datos.accion = template.accion;
    }
  }

  // Método para obtener las claves de las plantillas
  getTemplateKeys(): string[] {
    return Object.keys(this.quickScheduleTemplates);
  }
}
